import { NsColumn } from '@britishgasenergy/react-nucleus';
import { NsBackCta } from 'components/common/ns-back-cta/NsBackCta';
import { NsContent } from 'components/common/ns-content/NsContent';
import { NsProgress } from 'components/common/ns-progress/NsProgress';

export const testId = 'meterPointGuideTestId';

export const MeterPointGuideHeader = () => {
  return (
    <NsContent data-testid={testId}>
      <NsBackCta />
      <NsProgress />
      <br />
      <NsColumn hockeypitch="2:1">
        <NsContent>
          <h1>Where to find your meter reference numbers</h1>
          <h5>Let&apos;s find you the right tariff</h5>
        </NsContent>
      </NsColumn>
    </NsContent>
  );
};

export default MeterPointGuideHeader;
